import '../../../App.css';
import * as docx from "docx";
import {saveAs} from 'file-saver';
import React, {useState} from "react";
import {BorderStyle, ImageRun, Paragraph, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType,} from "docx";
import InputComponent from "../../../componennts/input";
import PhoneField from "../../../componennts/phone_field";
import FamilyField from "../../../componennts/family_field";
import TextAreaField from "../../../componennts/textarea";
import AddressField from "../../../componennts/v3/address_field";
import EducationField from "../../../componennts/v3/education_field";
import {Link} from "react-router-dom";
import { ArrowLeft } from 'react-bootstrap-icons';

function Profile_V4(props) {

    const [mode, setMode] = useState(false);
    const [modeClear, setModeClear] = useState(false);
    const [modeSaveDownload, setModeSaveDownload] = useState(false);

    // Function's
    const getParsedDate = (strDate, symbol, splitSymbol = ' ') => {

        var strSplitDate = String(strDate).split(splitSymbol);
        var date = new Date(strSplitDate[0]);
        // alert(date);
        var dd = date.getDate();
        var mm = date.getMonth() + 1; //January is 0!

        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + symbol + mm + symbol + yyyy;
        return date.toString();
    }

    // Field form
    const [firstName, setFirstName] = useState("");
    const [surName, setSurName] = useState("");
    const [lastName, setLastName] = useState("");
    const [dateBorn, setDateBorn] = useState("");
    const [job, setJob] = useState("");
    const [workPlace, setWorkPlace] = useState("");
    const [names, setNames] = useState("");
    const [names2, setNames2] = useState("");

    // V4.0 Field's
    const [region, setRegion] = useState('');
    const [publicLevel, setPublicLevel] = useState('низький');
    const [ocinkaPotencial, setOcinkaPotencial] = useState("1");

    const [vusnovokGiponeza, setVusnovokGiponeza] = useState('');
    const [vusnovokRecomendation, setVusnovokRecomendation] = useState('');

    const [authorName, setAuthorName] = useState('Юра');
    const [profileData, setProfileData] = useState('');

    // Photo upload

    const [file, setFile] = useState();
    const [fileYear, setFileYear] = useState();

    function handleChangeFile(e) {
        console.log(e.target.files);
        setFile(URL.createObjectURL(e.target.files[0]));
    }

    // FIELD's

    let [phones, setPhones] = useState([]);

    const handleChangePhonesValue = (i, e) => {
        const values = [...phones];
        values[i].text = e.target.value;
        setPhones(values);
    }

    const messengerOptionChange = (i, e, field) => {

        const values = [...phones];

        values[i][field] = e.target.checked;

        setPhones(values);
    }

    const handleInsertPhonesValue = () => {
        setPhones([...phones, {
            text: "",
            isTelegram: false,
            isViber: false,
            isWhatsApp: false,
            isSignal: false
        }]);
    }

    const handleRemovePhonesValue = (i) => {
        setPhones([
            ...phones.slice(0, i),
            ...phones.slice(i + 1)
        ]);
    }

    // Social media dynamic fields

    const _sourcesSocialMedia = [
        {
            value: "TG",
            label: "Telegram"
        },
        {
            value: "Viber",
            label: "Viber"
        },
        {
            value: "WhA",
            label: "WhatsApp"
        },
        {
            value: "Signal",
            label: "Signal"
        },
        {
            value: "VK",
            label: "ВКонтакте"
        },
        {
            value: "OK",
            label: "Однокласники"
        },
        {
            value: "Mail.ru",
            label: "Mail.ru"
        },
        {
            value: "Inst",
            label: "Instagram"
        },
        {
            value: "FB",
            label: "Facebook"
        },
        {
            value: "X-Twitter",
            label: "X/Twitter"
        },
        {
            value: "LinkedIn",
            label: "LinkedIn"
        },
        {
            value: "TK",
            label: "TikTok"
        },
        {
            value: "Джерело",
            label: "інше"
        }
    ];

    const [socialMedia, setSocialMedia] = useState([]);

    const handleChangeSocialMediaValue = (i, e, field) => {
        const values = [...socialMedia];
        values[i][field] = e.target.value;
        setSocialMedia(values);
    }

    const handleInsertSocialMediaValue = () => {
        setSocialMedia([...socialMedia, {
            source: "",
            url_or_id: "",
            username: ""
        }]);
    }

    const handleRemoveSocialMediaValue = (i) => {
        setSocialMedia([
            ...socialMedia.slice(0, i),
            ...socialMedia.slice(i + 1)
        ]);
    }

    // v3 data fields

    // ADDRESS
    const [addressData, setAddressData] = useState([]);

    const handleInsertAddressData = () => {
        setAddressData([...addressData, {
            address: "",
            note: ""
        }]);
    }

    const handleRemoveAddressData = (i) => {
        setAddressData([
            ...addressData.slice(0, i),
            ...addressData.slice(i + 1)
        ]);
    }

    const handleChangeAddressData = (i, e, field) => {
        const values = [...addressData];
        values[i][field] = e.target.value;
        setAddressData(values);
    }

    // EMAILS
    const [emailsData, setEmailsData] = useState([]);

    const handleInsertEmailsData = () => setEmailsData([...emailsData, {email: ""}]);

    const handleRemoveEmailData = (i) =>{
        setEmailsData([
            ...emailsData.slice(0, i),
            ...emailsData.slice(i + 1)
        ]);
    }

    // EDUCATION, EXPERIENCE, PUBLIC ACTIVATE
    const [educationData, setEducationData] = useState([]);
    const [workData, setWorkData] = useState([]);
    const [publicActivateData, setPublicActivateData] = useState([]);

    const handleInsertEducationData = () => setEducationData([...educationData,
        {
            data: "",
            name: "",
            description: "",
            note: "",
        }
    ]);

    const handleRemoveEducationData = (i) =>{
        setEducationData([
            ...educationData.slice(0, i),
            ...educationData.slice(i + 1)
        ]);
    }

    const handleChangeEducationData = (i, e, field) => {
        const values = [...educationData];
        values[i][field] = e.target.value;
        setEducationData(values);
    }

    // WORK
    const handleInsertWorkData = () => setWorkData([...workData,
        {
            data: "",
            name: "",
            description: "",
            note: "",
        }
    ]);

    const handleRemoveWorkData = (i) =>{
        setWorkData([
            ...workData.slice(0, i),
            ...workData.slice(i + 1)
        ]);
    }

    const handleChangeWorkData = (i, e, field) => {
        const values = [...workData];
        values[i][field] = e.target.value;
        setWorkData(values);
    }

    // PUBLIC ACTIVATE

    const handleInsertPublicActivateData = () => setPublicActivateData([...publicActivateData,
        {
            data: "",
            name: "",
            description: "",
            note: "",
        }
    ]);

    const handleRemovePublicActivateData = (i) =>{
        setPublicActivateData([
            ...publicActivateData.slice(0, i),
            ...publicActivateData.slice(i + 1)
        ]);
    }

    const handleChangePublicActivateData = (i, e, field) => {
        const values = [...publicActivateData];
        values[i][field] = e.target.value;
        setPublicActivateData(values);
    }

    // Family dynamic field's

    // FAMILY
    const [family, setFamily] = useState([
        // {
        //     relationship: "",
        //     name: "",
        //     surname: "",
        //     lastname: "",
        //     photo: "",
        //     phone: "",
        //     isTelegram: false,
        //     isViber: false,
        //     isWhatsapp: false,
        //     isSignal: false,
        //     links: "",
        //     dataBorn: ""
        // }
    ])

    const handleChangeFamilyValue = (i, e, field) => {
        const values = [...family];
        values[i][field] = e.target.value;
        setFamily(values);
    }

    const handleChangeFamilyMessengerValue = (i, e, field) => {
        const values = [...family];
        values[i][field] = e.target.checked;
        setFamily(values);
    }

    const handleInsertFamilyValue = () => {
        setFamily([...family, {
            relationship: "",
            name: "",
            surname: "",
            lastname: "",
            photo: "",
            phone: "",
            isTelegram: false,
            isViber: false,
            isWhatsapp: false,
            isSignal: false,
            links: "",
            dataBorn: ""
        }]);
    }

    const handleRemoveFamilyValue = (i) => {
        setFamily([
            ...family.slice(0, i),
            ...family.slice(i + 1)
        ]);
    }

    // google/yandex url's

    const [dataUrls, setDataUrls] = useState([
        // {
        //     url: "",
        //     description: ""
        // }
    ]);

    const setUrlToData = () => {
        setDataUrls([...dataUrls, {
            url: "",
            description: ""
        }])
    }

    const changeUrlInData = (i, e, field) => {
        const values = [...dataUrls];
        values[i][field] = e.target.value;
        setDataUrls(values);
    }

    const removeUrlFromData = (i) => {
        setDataUrls([
            ...dataUrls.slice(0, i),
            ...dataUrls.slice(i + 1)
        ]);
    }

    //
    const [dataUrls2, setDataUrls2] = useState([]);

    const setUrl2ToData = () => {
        setDataUrls2([...dataUrls2, {
            url: "",
            description: ""
        }])
    }

    const changeUrl2InData = (i, e, field) => {
        const values = [...dataUrls2];
        values[i][field] = e.target.value;
        setDataUrls2(values);
    }

    const removeUrl2FromData = (i) => {
        setDataUrls2([
            ...dataUrls2.slice(0, i),
            ...dataUrls2.slice(i + 1)
        ]);
    }
    //

    function handleChangeFilePhotoFamily(i, e) {

        const values = [...family];
        values[i].photo = URL.createObjectURL(e.target.files[0]);
        setFamily(values);
    }

    const _img = "/img.jpeg";

    const _title = surName + `_profile#${new Date().getTime()}`;


    function createFamilyList(familyData: any[]): any[] {

        const members = [];

        familyData.map(member => members.push(rowTableFamily(member)));

        return members;
    }

    function rowTableFamily(member: any): TableRow{

        const _relationshipType = {
            mother: "Мати",
            father: "Батько",
            brother: "Брат",
            sister: "Сестра",
            wife: "Дружина",
            husband: "Чоловік",
            sun: "Син",
            daughter: "Донька",
            grandmother: "Бабушка",
            grandfather: "Дедушка",
            mother_in_law: "Теща",
            father_in_law: "Тесть",
            godmother: "Хрещена Мати",
            godfather: "Хрещений Батько",
            nephew: "Племінник",
            niece: "Племінниця",
            stepfather: "Вітчим",
            stepmother: "Мачуха",
            friend: "Друг/Подруга",
            familiar: "Знайомий (а)",
            relative: "Родич",
            work_connection: "Робочий зв’язок",
            another_connection: "інший зв’язок"
        };

        return new TableRow({
            children: [
                new TableCell({
                    borders: {
                        top: {style: BorderStyle.NIL},
                        // bottom: {style: BorderStyle.NIL, size: 0, color: "#FFFFFF"},
                        left: {style: BorderStyle.NIL},
                        right: {style: BorderStyle.NIL, size: 0, color: "#FFFFFF"},
                    },
                    width: {
                        size: 25,
                        type: WidthType.PERCENTAGE
                    },
                    children: [new Paragraph({
                        children: [
                            new docx.TextRun({
                                text: _relationshipType[member.relationship],
                                italics: true,
                                bold: true,
                                break: 1,
                            }),
                        ]
                    })],
                    verticalAlign: VerticalAlign.TOP,
                }),

                new TableCell({
                    borders: {
                        top: {style: BorderStyle.NONE, size: 0, color: "#FFFFFF"},
                        // bottom: {style: BorderStyle.NONE, size: 0, color: "#FFFFFF"},
                        left: {style: BorderStyle.NONE, size: 0, color: "#FFFFFF"},
                        right: {style: BorderStyle.NONE, size: 0, color: "#FFFFFF"},
                    },
                    verticalAlign: VerticalAlign.TOP,
                    width: {
                        size: 75,
                        type: WidthType.PERCENTAGE
                    },
                    children:[
                        _memberFamilyCard(member)
                    ]
                })
            ]
        });
    }

    function _memberFamilyCard(member: any): Paragraph {

        // const blobPhotoMemberFamily = fetch(member.photo ? member.photo : _img).then(r => r.blob());

        // const _relationshipType = {
        //     mother: "Мати",
        //     father: "Батько",
        //     brother: "Брат",
        //     sister: "Сестра",
        //     wife: "Дружина",
        //     husband: "Чоловік",
        //     sun: "Син",
        //     daughter: "Донька",
        //     grandmother: "Бабушка",
        //     grandfather: "Дедушка",
        //     mother_in_law: "Теща",
        //     father_in_law: "Тесть",
        //     godmother: "Хрещена Мати",
        //     godfather: "Хрещений Батько",
        //     nephew: "Племінник",
        //     niece: "Племінниця",
        //     stepfather: "Вітчим",
        //     stepmother: "Мачуха",
        //     friend: "Друг/Подруга",
        //     familiar: "Знайомий (а)",
        //     relative: "Родич",
        //     work_connection: "Робочий зв’язок",
        //     another_connection: "інший зв’язок"
        // };

        return new Paragraph({
            children: [
                // new docx.TextRun({break: 1}),
                // new ImageRun({
                //     data: blobPhotoMemberFamily,
                //     transformation: {
                //         width: 50,
                //         height: 50,
                //     },
                // }),
                // new docx.TextRun({
                //     text: _relationshipType[member.relationship] + ' - ',
                //     italics: true,
                //     bold: true,
                //     break: 1,
                // }),
                new docx.TextRun({
                    text: member.surname + ' ' + member.name + ' ' + member.lastname + ' ',
                    // break: 1,
                    bold: true,
                }),
                new docx.TextRun({
                    text: isEmpty(member.dataBorn) ? '' : getParsedDate(member.dataBorn, '.') + ' р.н.',
                    // break: 1,
                    bold: true,
                }),
                new docx.TextRun({
                    text: member.phone + _checkMessengerActivityOnPhoneNumber([
                        member.isTelegram,
                        member.isViber,
                        member.isWhatsApp,
                        member.isSignal
                    ]),
                    break: 1,
                }),
                new docx.TextRun({
                    text: member.links,
                    break: 1,
                    // bold: true,
                }),
            ]
        });
    }

    function dataNullTitle(title, subtitle = ''){

        return new docx.Paragraph({
            children: [
                new TextRun({
                    text: title + ": ",
                    italics: true,
                    break: 1,
                }),
                new docx.TextRun({
                    text: subtitle,
                    bold: true,
                }),
            ]
        });
    }

    function _checkMessengerActivityOnPhoneNumber(messengers: any[]): String {

        // schema array for messengers
        const _labelMessengers = ['Telegram', 'Viber', 'WhatsApp', 'Signal'];

        let result = '';

        if (messengers.includes(true)) {

            result += ' Активний ';

            messengers.map((m, i) => {
                if (m) {
                    result += _labelMessengers[i] + ' '
                }
            })
        }

        return result;
    }

    function createPhonesList(phonesData: any[], title): Paragraph {

        const texts = phonesData.map(phone => new docx.TextRun({
            text: '+' + phone.text + _checkMessengerActivityOnPhoneNumber([
                phone.isTelegram,
                phone.isViber,
                phone.isWhatsApp,
                phone.isSignal
            ]),
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    function createSocialMediaLinksList(linkData: any[], title): Paragraph {

        const texts = linkData.map(link => new docx.TextRun({
            text: link.source + ' ' + link.url_or_id + (isEmpty(link.username) ? '' : ' @' + link.username),
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    function createUrlsDataList(linkData: any[], title): Paragraph {

        const texts = linkData.map(link => new docx.TextRun({
            text: link.url + (isEmpty(link.description) ? ' #' : ' - ' + link.description),
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    function createAddressDataList(addressData: any[], title): Paragraph {

        const texts = addressData.map(value => new docx.TextRun({
            text: value.address + (isEmpty(value.note) ? ' #' : ' - ' + value.note),
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    function createEmailsDataList(data: any[], title): Paragraph {

        const texts = data.map(value => new docx.TextRun({
            text: value.email,
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    function createEducationDataList(data: any[], title = ''): Paragraph {

        const texts = data.map(value => new docx.TextRun({
            text: value.data + " " +  value.name + " " +  value.description + " Примітка:" +  value.note,
            break: 1,
        }));

        texts.unshift(new TextRun({
            text: title + ": ",
            italics: true,
            break: 1,
        }));

        return new Paragraph({
            children: texts
        });
    }

    function rowRecord(title, data, bold = false, isTitle = false){

        return isTitle
            ?
            new docx.Paragraph({
                style: "coloredText",
                children:[
                    new TextRun({
                        text: title,
                        break: 1,
                    }),
                ]
            })
            :
            isEmpty(data) ? dataNullTitle(title, 'відсутні') : new Paragraph({
            children: [
                new TextRun({
                    text: title + ": ",
                    italics: true,
                    break: 1,
                }),
                new TextRun({
                    text: data,
                    bold: bold
                })
            ]
        });
    }

    function showListData(field, title = ''){
        switch(field){
            case 'emails':
                return emailsData.length > 0 ? createEmailsDataList(emailsData, title) : [];
            case 'address':
                return addressData.length > 0 ? createAddressDataList(addressData, title) : [];
            case 'phone':
                return phones.length > 0 ?createPhonesList(phones, title) : [];
            // case 'family':
            //     return family.length > 0 ? createFamilyList(family, title) : dataNullTitle(title, 'відсутні');
            case 'education':
                return educationData.length > 0 ? createEducationDataList(educationData, title) : dataNullTitle(title, 'відсутні');
            case 'work':
                return workData.length > 0 ? createEducationDataList(workData, title) : dataNullTitle(title, 'відсутні');
            case 'public_activate':
                return publicActivateData.length > 0 ? createEducationDataList(publicActivateData, title) : dataNullTitle(title, 'відсутня');
            case 'urls':
                return dataUrls.length > 0 ? createUrlsDataList(dataUrls, title) : dataNullTitle(title, 'відсутні');
            case 'urls2':
                return dataUrls2.length > 0 ? createUrlsDataList(dataUrls2, title) : dataNullTitle(title, 'відсутні');
            case 'social-media':
                return (socialMedia.length === 0 || socialMedia[0].source === '' || socialMedia[0].source === '#')
                    ? dataNullTitle(title, 'відсутні') : createSocialMediaLinksList(socialMedia, title);
            default:
                return '?';
        }
    }

    function isEmpty(value) {
        return (value == null || (typeof value === "string" && value.trim().length === 0));
    }

    const generate = async () => {

        const blobImage = await fetch(file ?? _img).then(r => r.blob());

        const tableFamily = new Table({
            // columnWidths: [350, 7550],
            width: {
                size: 100,
                type: WidthType.AUTO,
            },
            rows: createFamilyList(family)
        });

        const doc = new docx.Document({
            sections: [
                {
                    properties: {},
                    children: [
                        //
                        // PHOTO
                        //
                        new docx.Paragraph({
                            text: "Фото МВІ",
                            style: "coloredText"
                        }),
                        new docx.Paragraph({
                            children: [
                                new ImageRun({
                                    data: blobImage,
                                    transformation: {
                                        width: 150,
                                        height: 190,
                                    },
                                }),
                            ]
                        }),

                        //
                        // DATA
                        //
                        rowRecord('1. Основна інформація', '', false, true),
                        rowRecord("ПІБ фігури", `${surName + ' ' + firstName + ' ' + lastName}` + `, ${(dateBorn === "" || dateBorn == null) ? '' : getParsedDate(dateBorn, '.') + ' р.н.'}`, true, false),
                        rowRecord("Посада / Організація", `${job + ' ' + workPlace}`, true, false),
                        rowRecord("Регіон", region, true, false),
                        rowRecord("Рівень публічності (низький / середній / високій)", publicLevel, true, false),
                        rowRecord("Потенціал (оцінка 1 - 3)", ocinkaPotencial, true, false),

                        rowRecord('2. Біографія та діялність','', false, true),
                        showListData('education', 'Освіта'),
                        showListData('work', 'Кар\'єра / Посади'),
                        showListData('public_activate', 'Громадська діяльність / Політична активність'),


                        rowRecord('3. Соц. мережі', '', false, true),
                        showListData('phone', 'Контакти'),
                        showListData('emails', 'E-mails'),
                        showListData('address', 'Адреси'),
                        showListData('social-media', 'Соціальні мережі'),
                        rowRecord("Аналіз друзів / тегів / згадок", names, true, false),

                        rowRecord('4. Згадки в публічному просторі', '',  false, true),
                        showListData('urls', "Новини, блоги, згадки"),
                        showListData('urls2', "Фото, відео, публічні виступи"),

                        rowRecord(`5. Зв\'язки та оточення (${family.length})`, '',  false, true),
                        tableFamily,

                        rowRecord("Неформальні зв'язки (якщо виявлені)", names2, true, false),

                        rowRecord('6. Висновки та гіпотези', '',  false, true),
                        rowRecord("Основні гіпотези для входу", vusnovokGiponeza, false, false),
                        rowRecord("Рекомендовані теми, лінії контакту", vusnovokRecomendation, false, false),
                        //
                        // AUTHOR
                        //
                        new docx.Paragraph({
                            children: [
                                new TextRun({
                                    text: "Ім'я виконавця:" + " ",
                                    italics: true,
                                    break: 1,
                                }),
                                new TextRun({
                                    text: authorName === '' ? 'Хінцінський Ю. Ф.' : authorName,
                                    bold: true
                                }),
                                new TextRun({
                                    text: " ",
                                }),
                                new TextRun({
                                    text: "Дата:" + " ",
                                    italics: true
                                }),
                                new TextRun({
                                    text: `${(profileData === "" || profileData == null) ? new Date().toLocaleString() : getParsedDate(profileData, '.')}`,
                                    bold: true
                                })
                            ]
                        }),
                    ]
                }
            ],
            styles: {
                paragraphStyles: [
                    {
                        id: "normalText",
                        name: "Normal Text",
                        basedOn: "Normal",
                        run: {},
                    },
                    {
                        id: "coloredText",
                        name: "Colored Text",
                        basedOn: "Normal",
                        run: {
                            color: "6baed6",
                            bold: true
                        },
                    },
                ],
            }
        });

        docx.Packer.toBlob(doc).then(async (blob) => {
            console.log(blob);
            saveAs(blob, `${_title}.docx`);

            console.log("Document created successfully");
        });

        if (modeClear) {
            _clearFields();
        }

    }

    // Clear field's

    const _clearFields = () => {

        setFirstName('')
        setLastName('')
        setSurName('')
        setJob('')
        setWorkPlace('')
        setNames('')
        setNames2('')
        setDateBorn('')

        setFamily([])
        setDataUrls([])
        setDataUrls2([])
        setSocialMedia([])

        setPhones([
            {
                text: "",
                isTelegram: false,
                isViber: false,
                isWhatsApp: false,
                isSignal: false
            }
        ])

        setAddressData([])
        setEmailsData([])
        setEducationData([]);
        setWorkData([]);
        setPublicActivateData([])

        setFile();
        setFileYear("");

        // got to top profile
        window.scrollTo(0, 0)
    }

    return (

        <div id={'profile-v4'}>

            <div className="nav-page-profile position-absolute d-none d-md-block">


                <div className="d-flex flex-column text-start position-fixed">
                    <div className="text-start">
                        <Link to={'/projects'} className={'btn btn-light'}> <ArrowLeft /> Назад </Link>
                    </div>

                    <h2>Зміст</h2>
                    <a href="#basicInformation"
                       className={'p-2 text-decoration-none shadow-sm bg-white text-secondary border-bottom'}>
                        <small>1.Основна інформація</small>
                    </a>
                    <a href="#bio"
                       className={'p-2 text-decoration-none shadow-sm bg-white text-secondary'}>
                       <small>2.Біографія та діялність</small>
                    </a>
                    <a href="#contacts"
                       className={'p-2 text-decoration-none shadow-sm bg-white text-secondary'}>
                        <small>3.Соц. мережі</small>
                    </a>
                    <a href="#public"
                       className={'p-2 text-decoration-none shadow-sm bg-white text-secondary'}>
                        <small>4.Згадки в публічному просторі</small>
                    </a>
                    <a href="#family"
                       className={'p-2 text-decoration-none shadow-sm bg-white text-secondary border-bottom'}>
                        <small>5.Зв'язки та оточення</small>
                    </a>
                    <a href="#moreInfo"
                       className={'p-2 text-decoration-none shadow-sm bg-white text-secondary'}>
                        <small>6.Висновки та гіпотеза</small>
                    </a>

                    <div id="settings" className={'mt-3 p-1'}>
                        <small className="text-secondary mt-4">
                            <b>
                                Налаштування
                            </b>
                        </small>
                        <br/>
                        <div className="mt-2">
                            <b className={''}>Опція</b>
                        </div>
                        <div className="d-flex justify-content-between align-items-start">

                            <div className={'align-items-center d-flex'}>
                                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                     viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"/>
                                </svg>
                                {/*<b>Mode </b>  */}
                                <small className="text-secondary p-1">
                                    <b>Очищення</b>: {modeClear ? ' Вкл.' : ' Викл.'}
                                </small>
                            </div>

                            <input type="checkbox" id="toggleClear" className="checkbox"
                                   onChange={() => setModeClear(!modeClear)}/>

                            <label htmlFor="toggleClear" className="switch mt-1"></label>

                        </div>

                        <div className="d-none d-flex justify-content-between align-items-start">

                            <div className={'align-items-center d-flex'}>
                                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                     viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"/>
                                </svg>
                                {/*<b>Mode </b>  */}
                                <small className="text-secondary p-1">
                                    {mode ? ' Вкл.' : ' Викл.'}
                                </small>
                            </div>

                            <input type="checkbox" id="toggleDownload" className="checkbox"
                                   onChange={() => setMode(!mode)}/>

                            <label htmlFor="toggleDownload" className="switch mt-1"></label>

                        </div>

                        {localStorage.getItem('uid') &&
                        <div className="d-none d-flex justify-content-between align-items-start">

                            <div>
                                <div className={'align-items-center d-flex'}>
                                    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                         xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                         viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                              stroke-width="2"
                                              d="M19 6c0 1.657-3.134 3-7 3S5 7.657 5 6m14 0c0-1.657-3.134-3-7-3S5 4.343 5 6m14 0v6M5 6v6m0 0c0 1.657 3.134 3 7 3s7-1.343 7-3M5 12v6c0 1.657 3.134 3 7 3s7-1.343 7-3v-6"/>
                                    </svg>
                                    <small className="text-secondary p-1">
                                        {modeSaveDownload ? ' Вкл.' : ' Викл.'}
                                    </small>
                                </div>
                            </div>

                            <input type="checkbox" id="toggleSaveDownload" className="checkbox"
                                   onChange={() => setModeSaveDownload(!modeSaveDownload)}/>

                            <label htmlFor="toggleSaveDownload" className="switch mt-1"></label>

                            {/*<button className={'rounded-0 w-100 btn ' +( mode ? 'btn-success' : 'btn-secondary')} onClick={() => setMode(!mode)}>Mode {mode ? 'On' : 'Off'}</button>*/}

                        </div>
                        }

                        <a href="#information-section"
                           className={'text-decoration-none text-secondary align-items-center d-flex mt-2'}>
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"
                                 viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                            </svg>
                            <small className="text-secondary">Детальніше</small>
                        </a>

                    </div>
                </div>

            </div>

            <div className="form d-flex flex-wrap col-md-7 m-auto mb-5">

                <div className="col-md-12 text-start pb-5">
                    <h4 className="text-secondary text-uppercase">
                        Основна інформація
                    </h4>
                </div>

                <div id={'basicInformation'} className="col-md-4 col-12 p-1 wrap-image text-start">
                    <div className="col-md-12 col-12 text-start p-2">
                        <h4 className="text-secondary text-uppercase">
                            Фігура МВІ <small className="subtitle-desc">Фотографія</small>
                        </h4>
                    </div>
                    <img src={file ?? _img} alt="avatar"
                         className={'btn-img img-fluid border shadow col-md-10 col-12'}/>
                    <input type='file' id='file' onChange={handleChangeFile}/>
                </div>

                <div className="d-flex flex-wrap col-md-8 col-12 p-1">

                    <div className="bg-white shadow p-2 col-md-12 d-flex flex-wrap">
                        <div className="col-md-6 col-12 p-2">
                            <InputComponent
                                type={'text'}
                                name={'sur_name'}
                                value={surName}
                                onChange={(e) => setSurName(e.target.value)}
                                placeholder={'Прізвище'}
                                class={'form-control rounded-0 border-0 border-bottom'}
                            />
                        </div>
                        <div className="col-md-6 col-12 p-2">
                            <InputComponent
                                type={'text'}
                                name={'first_name'}
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder={'Імя'}
                                class={'form-control rounded-0 border-0 border-bottom'}
                            />
                        </div>
                        <div className="col-md-6 col-12 p-2">
                            <InputComponent
                                type={'text'}
                                name={'last_name'}
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder={'По-батькові'}
                                class={'form-control rounded-0 border-0 border-bottom'}
                            />
                        </div>
                        <div className="col-md-12 col-12 d-flex flex-wrap align-items-center">
                            <div className="col-md-6 col-12 p-2 text-end">
                                <small className="text-secondary">
                                    Дата народження:
                                </small>
                            </div>
                            <div className="col-md-6 col-12 p-2 text-start">
                                <InputComponent
                                    type={'date'}
                                    name={'date_born'}
                                    value={dateBorn}
                                    onChange={(e) => setDateBorn(e.target.value)}
                                    placeholder={'Дата народження'}
                                    class={'form-control rounded-0 border-0 border-bottom'}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-12 p-2">
                            <InputComponent
                                type={'text'}
                                name={'job'}
                                value={job}
                                onChange={(e) => setJob(e.target.value)}
                                placeholder={'Посада/Звання'}
                                class={'form-control rounded-0 border-0 border-bottom'}
                            />
                        </div>
                        <div className="col-md-6 col-12 p-2">
                            <InputComponent
                                type={'text'}
                                name={'work_place'}
                                value={workPlace}
                                onChange={(e) => setWorkPlace(e.target.value)}
                                placeholder={'Місце роботи'}
                                class={'form-control rounded-0 border-0 border-bottom'}
                            />
                        </div>

                    </div>
                </div>

                <div id="year-photo" className={'col-md-3 col-12'}>
                    <InputComponent
                        type={'number'}
                        name={'fileYear'}
                        value={fileYear}
                        onChange={(e) => setFileYear(e.target.value)}
                        placeholder={'Рік фото'}
                        class={'form-control rounded-0 border-0 border-bottom m-2 bg-transparent'}
                    />
                </div>

                <div className="col-md-12 col-12 mb-3">

                    <div className="d-flex flex-wrap justify-content-between mt-3">
                        <div className={'text-start col-md-6 col-12'}>
                            <small className="text-secondary">Регіон<br/>
                                <i className={'subtitle-desc'}>(адреса / місто / область)</i></small>
                            <InputComponent
                                type={'text'}
                                name={'region'}
                                value={region}
                                onChange={(e) => setRegion(e.target.value)}
                                placeholder={'Регіон'}
                                class={'form-control rounded-0 border'}
                            />
                        </div>

                        <div className={'text-start col-md-3 col-12'}>
                            <small className="text-secondary">Рівень публічності<br/>
                            <i className={'subtitle-desc'}>(низький / середній / високий)</i></small>
                            <select name={'public_level'} className={'form-control border rounded-0'} onChange={(e) => setPublicLevel(e.target.value)}>
                                <option value="низький" selected>низький</option>
                                <option value="середній">середній</option>
                                <option value="високий">високий</option>
                            </select>
                        </div>

                        <div className={'text-start col-md-3 col-12'}>
                            <small className="text-secondary">
                                Потенціал <br/> <i className={'subtitle-desc'}>(оцінка 1-3)</i>
                            </small>
                            <select name={'ocinka_potencial'} className={'form-control border rounded-0'} onChange={(e) => setOcinkaPotencial(e.target.value)}>
                                <option value="1" selected>оцінка 1</option>
                                <option value="2">оцінка 2</option>
                                <option value="3">оцінка 3</option>
                            </select>
                        </div>
                    </div>

                </div>

                <div className="col-md-12 text-start border-top pt-3">
                    <h4 className="text-secondary text-uppercase">
                        Біографія та діяльність
                    </h4>

                    <div className="col-md-12 text-start">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="text-secondary text-uppercase">
                                Освіта:
                            </h6>
                            <button onClick={handleInsertEducationData} className={'btn btn-secondary rounded-0'}>+</button>
                        </div>
                        <div className="d-flex flex-wrap">
                            {
                                educationData.map((education, i) => <div key={i} className="pb-2">
                                    <EducationField
                                        id={i}
                                        value={education}
                                        onChange={handleChangeEducationData}
                                        onRemove={handleRemoveEducationData}
                                    />
                                </div>)
                            }
                        </div>
                    </div>

                    <div className="col-md-12 text-start mt-1">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="text-secondary text-uppercase">
                                Кар'єра / Посади:
                            </h6>
                            <button onClick={handleInsertWorkData} className={'btn btn-secondary rounded-0'}>+</button>
                        </div>
                        <div className="d-flex flex-wrap">
                            {
                                workData.map((work, i) => <div key={i} className="pb-2">
                                    <EducationField
                                        id={i}
                                        value={work}
                                        onChange={handleChangeWorkData}
                                        onRemove={handleRemoveWorkData}
                                    />
                                </div>)
                            }
                        </div>
                    </div>

                    <div className="col-md-12 text-start mt-1">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="text-secondary text-uppercase">
                                Громадська діяльність / Політична активність:
                            </h6>
                            <button onClick={handleInsertPublicActivateData} className={'btn btn-secondary rounded-0'}>+</button>
                        </div>
                        <div className="d-flex flex-wrap">
                            {
                                publicActivateData.map((publicActivate, i) => <div key={i} className="pb-2">
                                    <EducationField
                                        id={i}
                                        value={publicActivate}
                                        onChange={handleChangePublicActivateData}
                                        onRemove={handleRemovePublicActivateData}
                                    />
                                </div>)
                            }
                        </div>
                    </div>
                </div>

                <div className="col-md-12 text-start border-top pt-3 mt-3">
                    <h4 className="text-secondary text-uppercase">
                        Контакти
                    </h4>

                    <div id={'contacts'} className="col-md-12 text-start mb-2">

                        <div className="border p-3 bg-white shadow">

                            <div id="address">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6 className="text-secondary text-uppercase opacity-50">
                                        Адреса
                                    </h6>

                                    <button onClick={handleInsertAddressData} className={'btn btn-secondary rounded-0'}>+
                                    </button>
                                </div>
                                <div id="list-address">
                                    {
                                        addressData.map((address, i) => <div key={i}
                                                                             className="d-flex justify-content-between align-items-center">

                                            <small className={'text-secondary pt-2 opacity-25'}>#{i+1}</small>

                                            <AddressField
                                                id={i}
                                                value={address}
                                                onChange={handleChangeAddressData}
                                                add={handleInsertAddressData}
                                                placeholder={'Місто, Вулиця'}
                                            />

                                            <button onClick={() => handleRemoveAddressData(i)}
                                                    className={'btn btn-outline-danger rounded-0'}>-</button>

                                        </div>)
                                    }

                                </div>
                            </div>

                            <hr/>
                            <div id="emails" className={''}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 className="text-secondary text-uppercase opacity-50">
                                        E-mail
                                    </h6>

                                    <button type={'button'} onClick={handleInsertEmailsData} className={'btn btn-secondary rounded-0'}>+</button>
                                </div>
                                <div id={'emails'} className={'p-1'}>
                                    {
                                        emailsData.map((value, i) => <div key={i}
                                                                          className="d-flex justify-content-between align-items-center pb-2">
                                            <small className={'text-secondary pt-2 opacity-25'}>#{i+1}</small>
                                            <InputComponent
                                                id={i}
                                                type={'text'}
                                                name={'e-mail#' + i}
                                                value={value.email}
                                                onChange={(e) => {
                                                    const values = [...emailsData];
                                                    values[i]['email'] = e.target.value;
                                                    setEmailsData(values);
                                                }}
                                                placeholder={'e-mail@domain.com'}
                                                class={'form-control w-75 rounded-0 border-0 border-bottom'}
                                            />
                                            <button onClick={() => handleRemoveEmailData(i)}
                                                    className={'btn btn-outline-danger rounded-0'}>-</button>
                                        </div>)
                                    }
                                </div>
                            </div>
                            <hr/>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="text-secondary text-uppercase opacity-50">
                                    Телефон
                                </h6>

                                <button onClick={handleInsertPhonesValue} className={'btn btn-secondary rounded-0'}>+</button>
                            </div>
                            <div id="phones">
                                {
                                    phones.map((phone, i) => <div key={i}>

                                            <PhoneField
                                                id={i}
                                                value={phone.text}
                                                onChange={(e) => handleChangePhonesValue(i, e)}
                                                add={handleInsertPhonesValue}
                                                remove={() => handleRemovePhonesValue(i)}
                                                messengerOptionChange={messengerOptionChange}
                                                telegram={phone.isTelegram}
                                                viber={phone.isViber}
                                                whatsapp={phone.isWhatsApp}
                                                signal={phone.isSignal}
                                            />

                                        </div>
                                    )
                                }
                            </div>
                            <hr/>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="text-secondary text-uppercase opacity-50">
                                    Соціальні мережі
                                </h6>

                                <button onClick={handleInsertSocialMediaValue}
                                        className={'btn btn-secondary rounded-0'}>+</button>
                            </div>
                            <div id="social-media">
                                {
                                    socialMedia.map((link, i) => <div key={i}
                                                                      className="d-flex justify-content-around align-items-center">

                                        <select className={'form-control rounded-0 border-0 border-bottom m-1'}
                                                onChange={(e) => handleChangeSocialMediaValue(i, e, 'source')}>
                                            <option value="#" selected disabled>- джерело -</option>
                                            {
                                                _sourcesSocialMedia.map((source, index) =>
                                                    <option key={index} value={source.value}
                                                            selected={source.value === link.source}>{source.label}</option>
                                                )
                                            }
                                        </select>
                                        <InputComponent
                                            type={'text'}
                                            name={'messenger_url_or_id'}
                                            value={link.url_or_id}
                                            onChange={(e) => handleChangeSocialMediaValue(i, e, 'url_or_id')}
                                            placeholder={'URL/ID'}
                                            class={'form-control rounded-0 border-0 border-bottom m-1'}
                                        />
                                        <InputComponent
                                            type={'text'}
                                            name={'messenger_username'}
                                            value={link.username}
                                            onChange={(e) => handleChangeSocialMediaValue(i, e, 'username')}
                                            placeholder={'@username'}
                                            class={'form-control rounded-0 border-0 border-bottom m-1'}
                                        />

                                        {/*{i !== 0 && */}
                                        <button onClick={() => handleRemoveSocialMediaValue(i)}
                                                className={'btn btn-outline-danger rounded-0'}>-</button>
                                        {/*}*/}
                                    </div>)
                                }
                            </div>

                        </div>

                    </div>

                    <TextAreaField
                        index={''}
                        id={'names'}
                        name={'names'}
                        title={"".toUpperCase()}
                        value={names}
                        onChange={(e) => setNames(e.target.value)}
                        placeholder={"Аналіз друзів / тегів / згадок"}
                        class={"form-control mb-2 rounded-0 shadow"}
                        typeSize={'full'}
                    />

                </div>

                <div className="col-md-12 text-start border-top pt-3 mt-3">
                    <h4 className="text-secondary text-uppercase">
                        Згадки в публічному просторі
                    </h4>

                    <div className={"col-md-12 text-start"}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="text-secondary text-uppercase">
                                Новини, блоги, згадки:
                            </h6>
                            <button onClick={setUrlToData} type={'button'}
                                    className={'btn btn-secondary rounded-0'}>+
                            </button>
                        </div>
                        <div className={(dataUrls.length > 0 && "bg-white shadow-lg") + " pb-2 pt-3"}>
                            {
                                dataUrls.map((url, i) => <div key={i}
                                                              className="d-flex align-items-center justify-content-between">
                                    <InputComponent
                                        type={'text'}
                                        name={'url_value[]'}
                                        value={url.url}
                                        onChange={(e) => changeUrlInData(i, e, 'url')}
                                        placeholder={'URL/Посилання'}
                                        class={'form-control m-1 rounded-0 border-0 border-bottom'}
                                    />
                                    <InputComponent
                                        type={'text'}
                                        name={'url_description[]'}
                                        value={url.description}
                                        onChange={(e) => changeUrlInData(i, e, 'description')}
                                        placeholder={'Опис'}
                                        class={'form-control m-1 rounded-0 border-0 border-bottom'}
                                    />
                                    <button onClick={() => removeUrlFromData(i)} type={'button'}
                                            className={'btn btn-danger rounded-0 m-1'}>-
                                    </button>
                                </div>)
                            }

                        </div>
                    </div>

                    <div className={"col-md-12 text-start"}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="text-secondary text-uppercase">
                                Фото, відео, публічні виступи:
                            </h6>
                            <button onClick={setUrl2ToData} type={'button'}
                                    className={'btn btn-secondary rounded-0'}>+
                            </button>
                        </div>
                        <div className={(dataUrls2.length > 0 && "bg-white shadow-lg") + " pb-2 pt-3"}>
                            {
                                dataUrls2.map((url, i) => <div key={i}
                                                              className="d-flex align-items-center justify-content-between">
                                    <InputComponent
                                        type={'text'}
                                        name={'url_value2[]'}
                                        value={url.url}
                                        onChange={(e) => changeUrl2InData(i, e, 'url')}
                                        placeholder={'URL/Посилання'}
                                        class={'form-control m-1 rounded-0 border-0 border-bottom'}
                                    />
                                    <InputComponent
                                        type={'text'}
                                        name={'url_description2[]'}
                                        value={url.description}
                                        onChange={(e) => changeUrl2InData(i, e, 'description')}
                                        placeholder={'Опис'}
                                        class={'form-control m-1 rounded-0 border-0 border-bottom'}
                                    />
                                    <button onClick={() => removeUrl2FromData(i)} type={'button'}
                                            className={'btn btn-danger rounded-0 m-1'}>-
                                    </button>
                                </div>)
                            }

                        </div>
                    </div>
                </div>

                <div className="col-md-12 text-start border-top pt-3 mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h4 className="text-secondary text-uppercase">
                            Зв'язки та оточення
                        </h4>

                        <button onClick={handleInsertFamilyValue} className={'btn btn-secondary rounded-0'}>+
                        </button>
                    </div>

                    <div className="bg-white shadow">

                        {
                            family.map((member, i) =>
                                <FamilyField
                                    id={i}
                                    value={member}
                                    change={handleChangeFamilyValue}
                                    remove={() => handleRemoveFamilyValue(i)}
                                    handleChangeFilePhotoFamily={(e) => handleChangeFilePhotoFamily(i, e)}
                                    handleChangeFamilyMessengerValue={handleChangeFamilyMessengerValue}
                                />
                            )
                        }
                    </div>
                    <TextAreaField
                        index={''}
                        id={'names2'}
                        name={'names2'}
                        title={"".toUpperCase()}
                        value={names2}
                        onChange={(e) => setNames2(e.target.value)}
                        placeholder={"Неформальні зв'язки (якщо виявлені)"}
                        class={"form-control mb-2 rounded-0 shadow"}
                        typeSize={'full'}
                    />
                </div>

                <div className="col-md-12 text-start border-top pt-3 mt-3">
                    <h4 className="text-secondary text-uppercase">
                        Висновки та гіпотези
                    </h4>

                    <TextAreaField
                        index={''}
                        id={'vusnovokGiponeza'}
                        name={'vusnovokGiponeza'}
                        title={"".toUpperCase()}
                        value={vusnovokGiponeza}
                        onChange={(e) => setVusnovokGiponeza(e.target.value)}
                        placeholder={"Основні гіпотези для входу"}
                        class={"form-control mb-2 rounded-0 shadow"}
                        typeSize={'full'}
                    />

                    <TextAreaField
                        index={''}
                        id={'vusnovokRecomendation'}
                        name={'vusnovokRecomendation'}
                        title={"".toUpperCase()}
                        value={vusnovokRecomendation}
                        onChange={(e) => setVusnovokRecomendation(e.target.value)}
                        placeholder={"Рекомендовані теми, лінії контакту"}
                        class={"form-control mb-2 rounded-0 shadow"}
                        typeSize={'full'}
                    />
                </div>

                <div className="col-md-12 d-flex justify-content-between align-items-center border-top pt-3 mt-3">

                   <div className={'pt-2'}>
                       <small className="text-secondary">
                           Ім'я виконавця: <b>{'Хінцінський Ю. Ф.'}</b>
                       </small>
                       <InputComponent
                           type={'text'}
                           name={'author_name'}
                           value={authorName}
                           onChange={(e) => setAuthorName(e.target.value)}
                           placeholder={'ПІБ'}
                           class={'form-control rounded-0 border-0 border-bottom'}
                       />
                   </div>
                    <div className={'pt-2'}>
                        <small className="text-secondary">
                            Дата: <b>{new Date().toLocaleString() + ""}</b>
                        </small>

                        <InputComponent
                            type={'date'}
                            name={'profile_data'}
                            value={profileData}
                            onChange={(e) => setProfileData(e.target.value)}
                            placeholder={'Дата'}
                            class={'form-control rounded-0 border-0 border-bottom'}
                        />
                    </div>
                </div>

                <div className="col-md-12 mt-5">
                    <button className={'btn btn-dark w-100 p-3 mt-2 rounded-0 pt-4 pb-4 text-uppercase'}
                            onClick={generate}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-cloud-download"
                             viewBox="0 0 16 16">
                            <path
                                d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"/>
                            <path
                                d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
                        </svg> Завантажить
                    </button>

                    <div className="pt-5">
                        <button onClick={_clearFields}
                                className={'btn text-decoration-none text-secondary text-uppercase'}>Очиистити профайл
                        </button>
                    </div>
                </div>


            </div>

            <div className="col-md-12 col-12 fixed-bottom p-2 text-end mb-5">
                <button className={'btn btn-dark col-md-2 p-3 mt-2 rounded-0 pt-4 pb-4 text-uppercase shadow-sm'}
                        onClick={generate}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         className="bi bi-cloud-download"
                         viewBox="0 0 16 16">
                        <path
                            d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"/>
                        <path
                            d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
                    </svg> Завантажить
                </button>
            </div>

        </div>
    );
}

export default Profile_V4;
